// Constants file for the Consumer Survey Frontend
// This file contains all magic numbers used throughout the application

// Step numbers
export const STEPS = {
  INITIAL: 1,
  SECOND: 2,
  THIRD: 3,
  FOURTH: 4,
  FIFTH: 5,
};

// Status values for advisor matching
export const STATUS = {
  FOUND_ADVISOR: "1",
  INTERVIEWING: "2",
  NEED_MORE_TIME: "3",
  OTHER: "4",
};

// Question IDs - Descriptive names based on actual question content
export const QUESTION_IDS = {
  // Slide 1 - Initial status question
  ADVISOR_REQUEST_STATUS: "1",

  // Slide 2.1 - Advisor selection and hiring reason
  WHICH_ADVISOR_CHOSEN: "2",
  MAIN_REASON_FOR_HIRING: "3",

  // Slide 2.1.1 - Interview follow-up
  INTERVIEWED_OTHER_ADVISORS: "4",

  // Slide 2.2 - Distance importance and advisor contact
  LOCATION_DISTANCE_IMPORTANCE: "7",
  ASSIST_DECISION_MAKING: "9",
  WHICH_ADVISORS_SPOKEN_TO: "10",

  // Slide 2.3 - Communication help and location importance
  NEED_COMMUNICATION_HELP: "11",
  LOCATION_IMPORTANCE_DECISION: "13",

  // Slide 2.4 - Hiring criteria and advisor contact
  MAIN_HIRING_CRITERIA: "14",
  WHICH_ADVISORS_CONTACTED: "15",
  ASSIST_DECISION_PROCESS: "16",

  // Slide 3 - Final satisfaction and feedback
  SATISFACTION_WITH_SERVICE: "17",
  IMPROVE_MATCHING_SERVICES: "18",
  ADDITIONAL_COMMUNICATION_METHODS: "19",
  HOW_HEARD_ABOUT_US: "20",
  LIKELIHOOD_TO_RECOMMEND: "21",
};

// Answer IDs for various questions
export const ANSWER_IDS = {
  // Slide1 status answers
  FOUND_ADVISOR: "1",
  INTERVIEWING_ADVISORS: "2",
  NEED_MORE_TIME: "3",
  OTHER_STATUS: "4",

  // Slide2_1 advisor selection
  ADVISOR_SELECTED: "5",

  // Slide2_1 hiring reasons
  PERSONALITY_FIT: "6",
  YEARS_EXPERIENCE: "7",
  TRACK_RECORD: "8",
  EXPERTISE: "9",
  LOCATION: "10",
  OTHER_REASON: "11",

  // Slide2_1_1 interview options
  YES_INTERVIEW: "12",
  NO_INTERVIEW: "13",

  // Slide2_2 distance importance
  NOT_IMPORTANT: "17",
  SOMEWHAT_IMPORTANT: "18",
  VERY_IMPORTANT: "19",

  // Slide2_2 decision making
  DECISION_ANSWER: "21",
  SPOKEN_TO_ANSWER: "22",

  // Slide2_3 communication
  NO_COMMUNICATION: "23",
  YES_COMMUNICATION: "24",
  NO_LONGER_INTERESTED: "25",

  // Slide2_3 location importance
  LOCATION_NOT_IMPORTANT: "27",
  LOCATION_SOMEWHAT_IMPORTANT: "28",
  LOCATION_VERY_IMPORTANT: "29",

  // Slide2_4 hiring criteria
  HIRING_PERSONALITY: "30",
  HIRING_EXPERIENCE: "31",
  HIRING_TRACK_RECORD: "32",
  HIRING_EXPERTISE: "33",
  HIRING_LOCATION: "34",
  HIRING_OTHER: "35",

  // Slide2_4 other answers
  SPOKEN_TO_OTHER: "36",
  ASSIST_WITH_OTHER: "37",

  // Slide3 satisfaction ratings (1-5 scale)
  SATISFACTION_1: "38",
  SATISFACTION_2: "39",
  SATISFACTION_3: "40",
  SATISFACTION_4: "41",
  SATISFACTION_5: "42",

  // Slide3 service improvement
  SERVICE_IMPROVEMENT: "43",

  // Slide3 communication methods
  COMMUNICATION_METHODS: "44",

  // Slide3 how did you hear about us
  HEAR_INTERNET: "45",
  HEAR_AD: "46",
  HEAR_PODCAST: "47",
  HEAR_FRIEND: "48",
  HEAR_OTHER: "49",

  // Slide3 recommendation ratings (1-5 scale)
  RECOMMEND_1: "50",
  RECOMMEND_2: "51",
  RECOMMEND_3: "52",
  RECOMMEND_4: "53",
  RECOMMEND_5: "54",
};

// Progress bar constants
export const PROGRESS_BAR = {
  INITIAL_WIDTH: "8.2909%",
  STEP_COUNT: 4,
  STEP_COUNT_OTHER: 3,
  WIDTH_ADJUSTMENT: 0.8,
};

// UI Constants
export const UI = {
  MARGIN_LEFT: "30px",
  TEXTAREA_ROWS: 4,
  TEXTAREA_COLS: 50,
  MARGIN_BOTTOM: "10px",
};

// String constants
export const STRINGS = {
  NA: "NA",
  OTHER: "other",
  NONE_OF_THE_ABOVE: "None of the above",
};

// Google Review URL
export const GOOGLE_REVIEW_URL = "https://g.page/r/CZ8HiKphANhBEAE/review";
